<div class="filter-block-wrapper">
  <h5 class="filter-title">{{'DATE' | translate}}</h5>
  <div class="date-section-line">
    <span>{{ this.displayDate(startDate, endDate) }}</span>
    <i #openCalendar class="fas fa-calendar-alt open-calendar" (click)="openPicker()"></i>
  </div>
  <div class="date-filter">
    <cc-date-picker
      *ngIf="datePickerOpened"
      (selected)="addDateRangeFilter($event.dateFrom, $event.dateTo)"
      [maxDate]="maxDate"
      [startDate]="startDate"
      [endDate]="endDate"
      [opens]="opens"
      class="date-range-input h-100-p">
    </cc-date-picker>
  </div>
</div>
